import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import FormSectionTitle from '../../../../components/FormSectionTitle';
import Button from '../../../../components/formControls/Button';
import {
  getEnterpriseInfo,
  isSaveEnterpriseInfoError,
  isSaveEnterpriseInfoLoaded,
} from '../../../../js/virtualOperator/selectors';
import { hasGrants } from '../../../../js/me/selectors';
import TextArea from '../../../../components/formControls/Textarea';
import { saveEnterpriseInfoRequest } from '../../../../js/virtualOperator/actions';
import ToastMessage from '../../../../components/messages/ToastMessage';
import LinkButton from '../../../../components/LinkButton';

const messages = defineMessages({
  info: {
    id: 'PbxVirtualOperatorCustomerInfo.info.label',
    defaultMessage: 'Customer info',
  },
  noInfo: {
    id: 'PbxVirtualOperatorCustomerInfo.noInfo',
    defaultMessage: 'No customer info',
  },
  showMore: {
    id: 'PbxVirtualOperatorCustomerInfo.showMore',
    defaultMessage: 'Show more',
  },
  showLess: {
    id: 'PbxVirtualOperatorCustomerInfo.showLess',
    defaultMessage: 'Show less',
  },
  buttonEdit: {
    id: 'PbxVirtualOperatorCustomerInfo.buttonEdit',
    defaultMessage: 'Edit',
  },
  buttonSave: {
    id: 'PbxVirtualOperatorCustomerInfo.buttonSave',
    defaultMessage: 'Save',
  },
  buttonCancel: {
    id: 'PbxVirtualOperatorCustomerInfo.buttonCancel',
    defaultMessage: 'Cancel',
  },
  placeholderContent: {
    id: 'PbxVirtualOperatorCustomerInfo.placeholderContent',
    defaultMessage: 'Enter your customer info here',
  },
  saveError: {
    id: 'PbxVirtualOperatorCustomerInfo.saveError',
    defaultMessage: 'Error saving customer info',
  },
});

const INFO_CHARS = 1000;

class PbxVirtualOperatorCustomerInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      info: props.info,
      editMode: false,
      showMore: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (
      !prevProps.saveLoaded &&
      this.props.saveLoaded &&
      !this.props.saveError
    ) {
      this.toggleEditMode();
    }
  }

  toggleEditMode = () => {
    const { editMode } = this.state;
    this.setState({
      editMode: !editMode,
    });
  };

  handleInfoChange = (event) => {
    this.setState({
      info: event.target.value,
    });
  };

  save = () => {
    this.props.saveInfo({
      info: this.state.info,
    });
  };

  render() {
    const {
      canEdit,
      saveError,
      intl: { formatMessage },
    } = this.props;
    return (
      <>
        <div>
          <FormSectionTitle className="mt-3 mb-3">
            {formatMessage(messages.info)}
          </FormSectionTitle>
          {saveError && (
            <ToastMessage
              type="danger"
              text={formatMessage(messages.saveError)}
            />
          )}
          {this.state.editMode ? (
            <TextArea
              maxLength={100000}
              rows={10}
              onChange={this.handleInfoChange}
              value={this.state.info || ''}
              id="info"
              name="info"
              placeholder={formatMessage(messages.placeholderContent)}
            />
          ) : this.state.info ? (
            <div
              style={{
                whiteSpace: 'break-spaces',
              }}
            >
              {this.state.showMore || this.state.info.length < INFO_CHARS ? (
                <React.Fragment>
                  <span>{this.state.info}</span>
                  {this.state.info.length > INFO_CHARS && (
                    <LinkButton onClick={() => this.setState({ showMore: false })}>
                      {formatMessage(messages.showLess)}
                    </LinkButton>
                  )}
                </React.Fragment>
              ) : (
                <span>
                  {this.state.info.substring(0, INFO_CHARS)}...
                  <LinkButton onClick={() => this.setState({ showMore: true })}>
                    {formatMessage(messages.showMore)}
                  </LinkButton>
                </span>
              )}
            </div>
          ) : (
            <span>{formatMessage(messages.noInfo)}</span>
          )}
          {canEdit && (this.state.editMode ? (
            <div className="pt-4 pb-4 text-center">
              <Button
                className="btn btn-primary"
                text={formatMessage(messages.buttonSave)}
                onClick={this.save}
                loading={!this.props.saveLoaded}
              />
              <Button
                className="btn btn-outline-primary ml-2"
                text={formatMessage(messages.buttonCancel)}
                onClick={this.toggleEditMode}
              />
            </div>
          ) : (
            <div className="pt-3 text-center">
              <Button
                className="btn btn-primary"
                text={formatMessage(messages.buttonEdit)}
                onClick={this.toggleEditMode}
              />
            </div>
          ))}
        </div>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    info: getEnterpriseInfo(state),
    saveLoaded: isSaveEnterpriseInfoLoaded(state),
    saveError: isSaveEnterpriseInfoError(state),
    canEdit: hasGrants(state, 'MANAGE_VIRTUAL_OPERATOR'),
  };
}

export default injectIntl(
  connect(mapStateToProps, {
    saveInfo: saveEnterpriseInfoRequest,
  })(PbxVirtualOperatorCustomerInfo)
);
